"use client"
/* eslint-disable custom-imports/no-react-hot-toast-import */
import { IconButton, Text } from "@/elements"
import { COLORS } from "@/theme"
import { XMarkIcon } from "@heroicons/react/24/outline"
import clsx from "clsx"
import toast, { Toaster as RHTToaster, ToastBar } from "react-hot-toast"

interface ToastProps {}

export const Toaster: React.FC<ToastProps> = () => {
  return (
    <RHTToaster
      position="bottom-right"
      gutter={8}
      toastOptions={{
        ariaProps: {
          role: "status",
          "aria-live": "assertive",
        },
        duration: 2500,
        position: "bottom-right",
        style: {
          width: "100%",
          maxWidth: "550px",
          background: "transparent",
          boxShadow: "none",
          border: "none",
          padding: "0",
        },
        success: {
          iconTheme: {
            primary: COLORS.green.default,
            secondary: "#ffffff",
          },
        },
        error: {
          iconTheme: {
            primary: COLORS.red.default,
            secondary: "#ffffff",
          },
        },
        loading: {
          iconTheme: {
            primary: COLORS.fg[2],
            secondary: COLORS.fg[3],
          },
        },
      }}>
      {t => (
        <ToastBar toast={t}>
          {({ icon, message }) => {
            return (
              <div
                style={{
                  boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.20)",
                }}
                className={clsx(
                  "flex w-full items-center justify-between gap-[6px] rounded-xl bg-bg-1 py-2 pr-2",
                  ["success", "error", "loading"].includes(t.type) ? "pl-6" : "pl-[14px]"
                )}>
                <div className="flex w-full items-baseline gap-1">
                  {icon}
                  <Text variant="body1" element="span" className="flex-1 [&>div]:justify-start">
                    {message}
                  </Text>
                </div>

                <IconButton
                  Icon={XMarkIcon}
                  variant="white"
                  size="medium"
                  // required to prevent the drawer from closing when clicking the toast dismiss button
                  id="toast-dismiss-button"
                  onClick={() => {
                    toast.dismiss(t.id)
                  }}
                />
              </div>
            )
          }}
        </ToastBar>
      )}
    </RHTToaster>
  )
}
